export const invertSvg = (svg: string): string => {
  let newSvg = svg
  newSvg = newSvg.replace(/fill="#020F66"/g, 'fill="white"').replace(/fill="#020f66"/g, 'fill="white"')
  newSvg = newSvg.replace(/stroke="#020F66"/g, 'stroke="white"').replace(/stroke="#020f66"/g, 'stroke="white"')

  // extract each fill hex value in newSvg and run it through the invertColor function
  const hexValues = newSvg.match(/fill="#[0-9A-Fa-f]{6}"/g)
  hexValues?.forEach((hexValue) => {
    const newHexValue = invertColor(hexValue.replace('fill="#', '').replace('"', ''))
    newSvg = newSvg.replace(hexValue, `fill="${newHexValue}"`)
  })
  return newSvg
}

export const invertColor = (hex: string) => {
  // brand color hex values to ignore when inverting colors
  if (['2CDDE9', '2cdde9'].includes(hex)) {
    return '#' + hex
  }

  // Remove the # if it exists
  hex = hex.replace('#', '')

  // Convert the hex color to RGB
  let r = parseInt(hex.substring(0, 2), 16)
  let g = parseInt(hex.substring(2, 2), 16)
  let b = parseInt(hex.substring(4, 2), 16)

  // Invert the RGB values
  r = 255 - r
  g = 255 - g
  b = 255 - b

  // Convert the RGB values back to hex
  return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)
}
